module.exports = __webpack_public_path__ + "img/4@2x.6241df6b.png";